var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.76,
    height: 62.04,
    viewBox: "0 0 38.76 62.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.9,14.22h-2.59V3.88c0-2.14-1.74-3.88-3.88-3.88s-3.88,1.74-3.88,3.88v10.34h-10.34V3.88c0-2.14-1.74-3.88-3.88-3.88s-3.88,1.74-3.88,3.88v10.34h-2.59c-4.31,0-5.41,6.05-1.29,7.52v10.58c0,3.78,5.17,4.54,5.17,6.46v3.88c0,2.14,1.74,3.88,3.88,3.88h1.29v1.29c0,1.68,1.08,3.1,2.59,3.64v9.29c0,1.71,2.59,1.71,2.59,0v-9.05h2.59v9.05c0,1.71,2.59,1.71,2.59,0v-9.29c1.5-.54,2.59-1.96,2.59-3.64v-1.29h1.29c2.14,0,3.88-1.74,3.88-3.88,0-4.06-.16-4.4.52-4.91,5.72-4.29,4.65-2.07,4.65-16.01,4.12-1.47,3.02-7.52-1.29-7.52Zm-7.76-10.34c0-1.71,2.59-1.71,2.59,0v10.34h-2.59V3.88Zm-18.1,0c0-1.71,2.59-1.71,2.59,0v10.34h-2.59V3.88Zm14.22,43.95c0,.71-.58,1.29-1.29,1.29h-5.17c-.71,0-1.29-.58-1.29-1.29v-1.29h7.76v1.29Zm10.34-15.51c0,.86-.39.94-3.62,3.36-3.36,2.52.1,8.27-2.84,8.27h-15.51c-.71,0-1.29-.58-1.29-1.29,0-6.43.52-5.43-4.65-9.31-.71-.54-.52-.29-.52-11.38h28.44v10.34Zm1.29-12.93H3.87c-1.71,0-1.71-2.59,0-2.59h31.03c1.71,0,1.71,2.59,0,2.59Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.73,33.84c-1.21,1.21.62,3.04,1.83,1.83.98-.98,2.67-.98,3.65,0,1.2,1.2,3.04-.62,1.83-1.83-1.95-1.96-5.36-1.96-7.31,0Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9,32c3.03-3.03,7.94-3.03,10.97,0,1.21,1.21,3.04-.62,1.83-1.83-4.04-4.04-10.58-4.04-14.63,0-1.21,1.21.62,3.04,1.83,1.83Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.38,37.49c-1.71,0-1.71,2.59,0,2.59s1.71-2.59,0-2.59Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.69667e47b9fb7bf7d2d0094f33a206e9.svg";
export { ForwardRef as ReactComponent };